interface ProductItem {
  id: string;
  name: string;
  taxonomy: string[];
  unit_price: number;
  unit_sale_price?: number;
  url: string;
  color?: string;
  size?: string;
  product_image_url?: string | false;
  stock?: number;
  quantity: number;
}

export const useInsiderSdk = () => {
  // ✅ move in composable
  const userStore = useUserStore();
  
  // ✅ check window object
  const initDataLayer = () => {
    if (process.client && typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
    }
  };


 // ✅ function add insider user data to payload
  const addInsiderUserValue = (payload: Record<string, any>) => {
    if (userStore.dataInsiderSdk && 
        typeof userStore.dataInsiderSdk === 'object' && 
        !Array.isArray(userStore.dataInsiderSdk)) {
      let language = 'en_MY';
      const detect_country = useCookie('detect_country');
    if (detect_country.value === 'ms-my') {
        language = 'ms_MY';
    }

    console.log('--- language: ',language);

      const result = toKeyValueArray(userStore.dataInsiderSdk,language);
      if (result) {
        payload.insider_user_value = result;
      }
    }
  };
 const toKeyValueArray = (obj: any,language:string) => 
  obj?.custom ? {
    uuid: obj.uuid,
    gender: obj.gender,
    birthday: obj.birthday,
    has_transacted: (obj.custom.user_lifetime || 0) > 0,
    //transaction_count: obj.custom.user_lifetime || 0,
    gdpr_optin: obj.gdpr_optin,
    email_optin: obj.email_optin,
    name: obj.name,
    surname: obj.surname,
    username: obj.username,
    email: obj.email,
     phone_number:
        obj.phone_number?.trim() &&
        obj.phone_number.trim() !== '+'
          ? obj.phone_number.trim()
          : '',
    sms_optin: obj.sms_optin,
    whatsapp_optin: obj.whatsapp_optin,
    language: language,
    returning: (obj.custom.user_lifetime || 0) > 1
  } : obj.uuid !== '' 
        ? obj 
        : null;



const trackInsiderSdkEvent = (
  event: string,
  type: string,
  insider_currency: string,
  extra?: Record<string, any> 
) => {
  try {
    if (process.client && typeof window !== 'undefined') {
      initDataLayer();

      const payload: Record<string, any> = {
        event
      };

      if (type) {
        payload.type = type;
      }

      if (insider_currency) {
        payload.insider_currency = insider_currency;
      }

      addInsiderUserValue(payload);

      
      if (extra && typeof extra === 'object') {
        Object.assign(payload, extra);
      }

      window.dataLayer.push(payload);

      console.log('Insider SDK Event tracked:', payload);
    }
  } catch (error) {
    console.error(`Error in trackInsiderSdkEvent (${event}):`, error);
  }
};



  const trackEventCart = (
    event: string,
    type: string,
    items: ProductItem[],
    currency: string,
    id: string,
  ) => {
    try {
      if (process.client && typeof window !== 'undefined') {
        initDataLayer();
        
        let item: any = {};
        
        if (id === '') {
          item = items;
        } else {
          if (!items || !Array.isArray(items)) {
            console.warn('Invalid items array for trackEventCart');
            return;
          }
          
          // const found = items.find(i => i.name === name.toString());
          // if (!found) {
          //   console.warn(`Item with id ${id} not found in items array`);
          //   return;
          // }
          
          item = {
            id: found.id.toString(),
            name: found.name,
            taxonomy: found.taxonomy,
            unit_price: found.unit_price,
            unit_sale_price: (found.unit_sale_price ?? found.unit_price),
            quantity: found.quantity,
            url: found.url,
            product_image_url: found.product_image_url || '',
            ...(found.color && found.color.trim() !== '' ? { color: found.color } : {}),
            ...(found.stock != null ? { stock: found.stock } : {})
          };
        }

        const payload: Record<string, any> = {
        event,
        type,
        item,
        currency,
        

      };
     addInsiderUserValue(payload);

       window.dataLayer.push(payload);
        
        console.log('Cart event tracked:', { event, type, currency, item });
      }
    } catch (error) {
      console.error(`Error in trackEventCart (${event}):`, error);
    }
  };

  const trackInsiderSdkCart = (
    event: string,
    type: string,
    items: ProductItem[],
    currency: string,
    shipping_cost: string,
    total: string
  ) => {
    try {
      if (process.client && typeof window !== 'undefined') {
        initDataLayer();
        
        if (!items || !Array.isArray(items)) {
          console.warn('Invalid items array for trackInsiderSdkCart');
          return;
        }

        window.dataLayer.push({
          event: event, 
          type: type,
          insider_currency: currency,
          insider_cart_value: {
            shipping_cost: shipping_cost,
            total: total,
            items: items
          }
        });
        
        console.log('Insider SDK Cart tracked:', { type, currency, shipping_cost, total, items });
      }
    } catch (error) {
      console.error(`Error in trackInsiderSdkCart (${event}):`, error);
    }
  };

  

  // ✅ Return all functions
  return {
    trackInsiderSdkEvent,
    trackEventCart,
    trackInsiderSdkCart,
  };
};